<template>
  <el-drawer
    title="联系人信息"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="30%"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    @closed="onDrawerClosed"
  >
    <drawer-wrapper with-footer class="contacts-drawer form-drawer">
      <el-form
        :model="contactForm"
        :rules="contactsRules"
        ref="contactForm"
        class="contacts-form rule-form"
        label-position="top"
        :inline-message="true"
        v-loading="drawerLoading"
      >
        <div class="form-drawer-alert">
          <div>
            <img class="icon-warning" src="../../assets/icon/warning.svg" />
          </div>
          <div>
            <p>{{ `姓名必填，${tipText}` }}</p>
            <p v-if="params.drawerType === 'edit'">
              删除联系方式后可能会收不到告警通知，请谨慎操作
            </p>
          </div>
        </div>

        <el-form-item class="form-tip-top" label="联系人姓名：" prop="name">
          <el-input
            type="input"
            v-model="contactForm.name"
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <p class="form-tip">
            联系人姓名最多可以输入 8 个字符，并且只能输入字母、数字、下划线或中文
          </p>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input type="input" v-model="contactForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input type="input" v-model="contactForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item v-if="isWorkWechatEnabled" label="企业微信 ID：" prop="workWxId">
          <el-select
            v-model="contactForm.workWxId"
            filterable
            clearable
            placeholder="搜索联系人"
            style="width:100%;"
            @visible-change="resetContactsDetail"
          >
            <el-option
              v-for="contact in contactOptions"
              :key="contact.userId"
              :label="contact.name"
              :value="contact.userId"
            >
              <div class="contacts-detail-inner" v-loading="contact.popoverLoading">
                <span>{{ contact.name }}</span>
                <el-popover
                  placement="bottom"
                  trigger="manual"
                  width="300"
                  :visible-arrow="false"
                  :value="contactDetail.userId === contact.userId"
                >
                  <ul class="contacts-detail-info" @click.stop>
                    <li class="contacts-detail-info-name">
                      {{ contactDetail.name }}
                    </li>
                    <li>
                      <span class="contacts-detail-info-title">电话：</span
                      >{{ contactDetail.phone ? contactDetail.phone : '暂无' }}
                    </li>
                    <li>
                      <span class="contacts-detail-info-title">邮件：</span
                      >{{ contactDetail.email ? contactDetail.email : '暂无' }}
                    </li>
                  </ul>
                  <el-button
                    v-if="contactDetail.userId !== contact.userId"
                    slot="reference"
                    type="text"
                    @click.stop="viewContactDetail(contact)"
                    >详情</el-button
                  >
                  <el-button v-else slot="reference" type="text" @click.stop="resetContactsDetail"
                    >关闭</el-button
                  >
                </el-popover>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">
          {{ loading ? `${params.submitLabel}中 ...` : params.submitLabel }}
        </el-button>
      </template>
    </drawer-wrapper>
  </el-drawer>
</template>

<script>
import {
  reqCreateContact,
  reqUpdateContact,
  reqShowContact,
  reqFetchWorkWxContacts,
  reqShowWorkWxContact,
  reqJudgeContactExisted
} from '../../api/contact';
import Validator from '../../utils/Validator';
import DrawerWrapper from '../../components/DrawerWrapper/Index';
import * as _cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'ContactsCreatorAndEditor',

  components: {
    DrawerWrapper
  },

  data() {
    const validatorName = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNoSpace())
        .register(validator.isNameStandardStr())
        .register(validator.lenRange(8))
        .validate();
    };

    const checkNameRepeat = async (rule, value, callback) => {
      try {
        if (!this.isSubmitting) {
          return;
        }
        const { data } = await reqJudgeContactExisted({
          judgement: value,
          type: 1,
          id: this.params.id
        });

        if (data) {
          callback(new Error('联系人姓名重复'));
        } else {
          callback();
        }
      } catch {
        callback(new Error('重复校验失败，请稍后重试'));
      }
    };

    const checkPhoneRepeat = async (rule, value, callback) => {
      try {
        if (!this.isSubmitting || !value) {
          return;
        }
        const { data } = await reqJudgeContactExisted({
          judgement: value,
          type: 2,
          id: this.params.id
        });

        if (data) {
          callback(new Error('联系人手机号重复'));
        } else {
          callback();
        }
      } catch {
        callback(new Error('重复校验失败，请稍后重试'));
      }
    };

    const checkEmailRepeat = async (rule, value, callback) => {
      try {
        if (!this.isSubmitting || !value) {
          return;
        }
        const { data } = await reqJudgeContactExisted({
          judgement: value,
          type: 3,
          id: this.params.id
        });

        if (data) {
          callback(new Error('联系人邮箱重复'));
        } else {
          callback();
        }
      } catch {
        callback(new Error('重复校验失败，请稍后重试'));
      }
    };

    const checkWorkWechatRepeat = async (rule, value, callback) => {
      try {
        if (!this.isSubmitting || !value) {
          return;
        }
        const { data } = await reqJudgeContactExisted({
          judgement: value,
          type: 4,
          id: this.params.id
        });

        if (data) {
          callback(new Error('联系人企业微信重复'));
        } else {
          callback();
        }
      } catch {
        callback(new Error('重复校验失败，请稍后重试'));
      }
    };

    const validatorPhone = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.isMobile()).validate();
    };

    const validatorInformation = (rule, value, cb) => {
      if (!this.contactForm.phone && !this.contactForm.email && !this.contactForm.workWxId) {
        cb(new Error(this.tipText));
      } else {
        cb();
      }
    };

    return {
      params: {
        drawerType: '',
        id: '',
        submitLabel: ''
      },
      drawerVisible: false,
      contactOriginData: {}, // 编辑时，用于保存表单的初始数据
      contactForm: {
        name: '',
        phone: '',
        email: '',
        workWxId: ''
      },
      contactsRules: {
        name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          { validator: checkNameRepeat },
          { validator: validatorName, trigger: 'blur' }
        ],
        phone: [
          { validator: validatorPhone, trigger: 'blur' },
          { validator: validatorInformation },
          { validator: checkPhoneRepeat }
        ],
        email: [
          { type: 'email', message: '邮箱输入有误', trigger: 'blur' },
          { validator: validatorInformation },
          { validator: checkEmailRepeat }
        ],
        workWxId: [{ validator: validatorInformation }, { validator: checkWorkWechatRepeat }]
      },
      isSubmitting: false,
      contactVisible: false,
      contactDetail: {
        userId: '',
        name: '',
        phone: '',
        email: ''
      },
      contactOptions: [],
      loading: false,
      drawerLoading: false,
      popoverLoading: false,
      isWorkWechatEnabled: this.$store.state.user.isWorkWechatEnabled, // 企业微信是否可用
      tipText: this.$store.state.user.isWorkWechatEnabled
        ? '手机号，邮箱和企业微信至少填一个'
        : '手机号和邮箱至少填一个'
    };
  },

  methods: {
    async open({ drawerType, contactId }) {
      this.drawerVisible = true;
      this.params.id = contactId ? contactId : '';
      this.params.drawerType = drawerType;
      this.params.submitLabel = drawerType === 'edit' ? '保存' : '创建';

      try {
        this.drawerLoading = true;

        if (this.isWorkWechatEnabled) {
          this.getWorkWxContacts();
        }

        // 编辑项目获取数据详情
        if (drawerType === 'create') {
          return;
        }

        const { data } = await reqShowContact(contactId);

        this.contactForm.name = data.name;
        this.contactForm.phone = data.phone;
        this.contactForm.email = data.email;
        this.contactForm.workWxId = data.workWxId;

        this.contactOriginData = _cloneDeep(this.contactForm);
      } finally {
        this.drawerLoading = false;
      }
    },
    async getWorkWxContacts() {
      try {
        this.drawerLoading = true;
        const { data } = await reqFetchWorkWxContacts();
        this.contactOptions = data.map(user => ({
          userId: user.userid,
          name: user.name
        }));
      } finally {
        this.drawerLoading = false;
      }
    },
    async onSubmit() {
      try {
        this.isSubmitting = true;
        await this.$refs.contactForm.validate();
      } catch {
        return;
      } finally {
        this.isSubmitting = false;
      }

      try {
        this.loading = true;

        if (this.params.drawerType === 'edit') {
          // 编辑联系人时，如果删除联系方式，给出提示
          if (
            (!this.contactForm.phone && this.contactOriginData.phone) ||
            (!this.contactForm.email && this.contactOriginData.email) ||
            (!this.contactForm.workWxId && this.contactOriginData.workWxId)
          ) {
            try {
              await this.$msgbox({
                title: `警告`,
                message: `删除联系方式可能会导致一些告警不可用，仍要继续吗？`,
                type: 'warning',
                showCancelButton: true,
                beforeClose: async (action, instance, done) => {
                  if (action === 'cancel') {
                    done();
                    return;
                  }
                  this.loading = true;
                  done();
                }
              });
            } catch (e) {
              if (e === 'cancel') return;
            } finally {
              this.loading = false;
            }
          }
          await reqUpdateContact({ ...this.contactForm, id: this.params.id });
          this.$emit('submit', this.params.drawerType);
        } else {
          const { data } = await reqCreateContact(this.contactForm);
          this.$emit('submit', this.params.drawerType, data.name, data.id);
        }

        this.drawerVisible = false;
      } finally {
        this.loading = false;
      }
    },
    onDrawerClosed() {
      this.$refs.contactForm.resetFields();
      this.contactVisible = false;

      this.contactForm = {
        name: '',
        phone: '',
        email: '',
        workWxId: ''
      };
    },
    async viewContactDetail(contact) {
      try {
        contact.popoverLoading = true;
        const { data } = await reqShowWorkWxContact(contact.userId);
        const contactData = JSON.parse(data);
        this.contactDetail.userId = contactData.userid;
        this.contactDetail.name = contactData.name;
        this.contactDetail.phone = contactData.mobile;
        this.contactDetail.email = contactData.email;
      } catch (e) {
        this.$message.error('网络连接超时，请稍候重试');
      } finally {
        contact.popoverLoading = false;
      }
    },
    resetContactsDetail() {
      this.contactDetail = {
        userId: '',
        name: '',
        phone: '',
        email: ''
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.contacts-drawer {
  &-area {
    width: 100%;
  }
}

.contacts-detail {
  &-inner {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  &-info {
    padding: 0;
    margin: 0;
    list-style: none;
    line-height: 24px;

    &-title {
      display: block;
      float: left;
      width: 46px;
    }

    &-name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}
</style>
